(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catalyst-collection-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const escapeHtml = (value = '') => String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

    const initCatalogueSearch = (form) => {
      if (form.dataset.autocompleteReady === 'true') return;
      form.dataset.autocompleteReady = 'true';

      const input = form.querySelector('[data-cs-search-input]');
      const results = form.querySelector('[data-cs-search-results]');
      if (!input || !results) return;

      let timer = null;
      let controller = null;
      let activeIndex = -1;
      let resultLinks = [];

      const closeResults = () => {
        results.hidden = true;
        results.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
        activeIndex = -1;
        resultLinks = [];
      };

      const setActive = (index) => {
        resultLinks.forEach((link) => link.classList.remove('is-active'));
        if (!resultLinks.length) return;
        activeIndex = (index + resultLinks.length) % resultLinks.length;
        const active = resultLinks[activeIndex];
        active.classList.add('is-active');
        active.scrollIntoView({ block: 'nearest' });
      };

      const searchUrl = (term, field) => {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const url = new URL(root + 'search/suggest.json', window.location.origin);
        url.searchParams.set('q', term);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '8');
        url.searchParams.set('resources[limit_scope]', 'all');
        url.searchParams.set('resources[options][fields]', field);
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        return url;
      };

      const fetchMatches = async (term, field, signal) => {
        const response = await fetch(searchUrl(term, field), { signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Search request failed');
        const data = await response.json();
        return data?.resources?.results?.products || [];
      };

      const renderResults = (products, term) => {
        if (!products.length) {
          results.innerHTML = '<div class="cs-catalogue-search__status">No packs found for “' + escapeHtml(term) + '”</div>';
          results.hidden = false;
          input.setAttribute('aria-expanded', 'true');
          resultLinks = [];
          return;
        }

        results.innerHTML = products.map((product) => {
          const featured = product.featured_image;
          const imageUrl = (featured && typeof featured === 'object' && featured.url) || (typeof featured === 'string' ? featured : '') || product.image || '';
          const image = imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="" loading="lazy">' : '';
          return '<a class="cs-catalogue-search__suggestion" role="option" href="' + escapeHtml(product.url || '#') + '">' +
            '<span class="cs-catalogue-search__suggestion-image">' + image + '</span>' +
            '<span><span class="cs-catalogue-search__suggestion-title">' + escapeHtml(product.title || '') + '</span><span class="cs-catalogue-search__suggestion-meta">View sample pack</span></span>' +
            '<span class="cs-catalogue-search__suggestion-arrow" aria-hidden="true">↗</span></a>';
        }).join('');

        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        resultLinks = Array.from(results.querySelectorAll('.cs-catalogue-search__suggestion'));
        activeIndex = -1;
      };

      const runSearch = async () => {
        const term = input.value.trim();
        if (!term) { closeResults(); return; }

        if (controller) controller.abort();
        controller = new AbortController();
        results.innerHTML = '<div class="cs-catalogue-search__status">Searching…</div>';
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');

        try {
          const groups = await Promise.all([
            fetchMatches(term, 'title', controller.signal),
            fetchMatches(term, 'tag', controller.signal),
            fetchMatches(term, 'body', controller.signal)
          ]);

          const seen = new Set();
          const ranked = [];
          groups.forEach((group) => group.forEach((product) => {
            const key = product.id || product.url || product.handle || product.title;
            if (!key || seen.has(key)) return;
            seen.add(key);
            ranked.push(product);
          }));
          renderResults(ranked.slice(0, 8), term);
        } catch (error) {
          if (error.name === 'AbortError') return;
          closeResults();
        }
      };

      input.addEventListener('input', () => {
        window.clearTimeout(timer);
        const term = input.value.trim();
        if (!term) { closeResults(); return; }
        timer = window.setTimeout(runSearch, 180);
      });

      input.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' && resultLinks.length) {
          event.preventDefault();
          setActive(activeIndex + 1);
        } else if (event.key === 'ArrowUp' && resultLinks.length) {
          event.preventDefault();
          setActive(activeIndex - 1);
        } else if (event.key === 'Enter' && activeIndex >= 0 && resultLinks[activeIndex]) {
          event.preventDefault();
          resultLinks[activeIndex].click();
        } else if (event.key === 'Escape') {
          closeResults();
        }
      });

      document.addEventListener('click', (event) => {
        if (!form.contains(event.target)) closeResults();
      });
    };

    const initAll = () => document.querySelectorAll('[data-cs-catalogue-search]').forEach(initCatalogueSearch);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catalyst-home"] && !Shopify.designMode) return;
  try {
    
function setupCatalystSlider(root){
  const slider=root.querySelector('[data-cs-slider]');
  if(!slider||slider.dataset.ready==='true')return;
  slider.dataset.ready='true';
  const slides=[...slider.querySelectorAll('[data-cs-slide]')];
  const dots=[...slider.querySelectorAll('[data-cs-dot]')];
  if(slides.length<2)return;
  let index=0;
  let timer;
  const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const show=(next)=>{
    slides[index].classList.remove('is-active');
    slides[index].setAttribute('aria-hidden','true');
    slides[index].inert=true;
    dots[index]?.classList.remove('is-active');
    index=(next+slides.length)%slides.length;
    slides[index].querySelectorAll('img[data-src]').forEach((image)=>{
      if(image.dataset.srcset){image.srcset=image.dataset.srcset;delete image.dataset.srcset;}
      image.src=image.dataset.src;delete image.dataset.src;
    });
    slides[index].inert=false;
    slides[index].classList.add('is-active');
    slides[index].setAttribute('aria-hidden','false');
    dots[index]?.classList.add('is-active');
  };
  const stop=()=>{if(timer)window.clearInterval(timer);timer=null;};
  const start=()=>{if(!reduceMotion){stop();timer=window.setInterval(()=>show(index+1),5500);}};
  slider.querySelector('[data-cs-prev]')?.addEventListener('click',()=>{show(index-1);start();});
  slider.querySelector('[data-cs-next]')?.addEventListener('click',()=>{show(index+1);start();});
  dots.forEach((dot,i)=>dot.addEventListener('click',()=>{show(i);start();}));
  slider.addEventListener('mouseenter',stop);
  slider.addEventListener('mouseleave',start);
  slider.addEventListener('focusin',stop);
  slider.addEventListener('focusout',start);
  start();
}

function setupCatalystRandomiser(root){
  const section=root.querySelector('[data-cs-randomiser]');
  const button=root.querySelector('[data-cs-randomise]');
  if(!section||!button||button.dataset.ready==='true')return;
  button.dataset.ready='true';
  const label=button.querySelector('[data-cs-randomise-label]');
  const status=root.querySelector('[data-cs-randomise-status]');
  const readout=root.querySelector('[data-cs-reaction-readout]');
  const revealImage=root.querySelector('[data-cs-reveal-image]');
  const revealTitle=root.querySelector('[data-cs-reveal-title]');
  const wait=(ms)=>new Promise(resolve=>window.setTimeout(resolve,ms));
  button.addEventListener('click',async()=>{
    button.classList.add('is-spinning');
    button.setAttribute('aria-busy','true');
    section.classList.remove('is-revealed');
    section.classList.add('is-reacting');
    if(label)label.textContent='MIXING...';
    if(status)status.textContent='INITIATING CATALYST REACTION';
    if(readout)readout.textContent='IGNITION';
    try{
      const productPromise=fetch('/products.json?limit=250',{headers:{'Accept':'application/json'}}).then(response=>{
        if(!response.ok)throw new Error('Could not load products');
        return response.json();
      });
      const stages=[
        ['SCANNING CATALYST LIBRARY','SCANNING'],
        ['COMBINING GENRES','BLENDING'],
        ['CATALYSING IDEAS','REACTING'],
        ['STABILISING REACTION','STABILISING']
      ];
      for(const stage of stages){
        if(status)status.textContent=stage[0];
        if(readout)readout.textContent=stage[1];
        await wait(470);
      }
      const data=await productPromise;
      const products=(data.products||[]).filter(product=>product&&product.handle);
      if(!products.length)throw new Error('No products found');
      const chosen=products[Math.floor(Math.random()*products.length)];
      const image=(chosen.image&&chosen.image.src)||(chosen.images&&chosen.images[0]&&chosen.images[0].src)||'';
      section.classList.remove('is-reacting');
      section.classList.add('is-revealed');
      if(revealImage){
        if(image){revealImage.src=image;revealImage.alt=String(chosen.title||'Catalyst sample pack');}
        else{revealImage.removeAttribute('src');revealImage.alt='';}
      }
      if(revealTitle)revealTitle.textContent=String(chosen.title||'Random Pack');
      if(label)label.textContent='REACTION COMPLETE';
      if(status)status.textContent='PACK SELECTED';
      if(readout)readout.textContent='COMPLETE';
      await wait(1250);
      window.location.assign('/products/'+encodeURIComponent(chosen.handle));
    }catch(error){
      section.classList.remove('is-reacting','is-revealed');
      button.classList.remove('is-spinning');
      button.removeAttribute('aria-busy');
      if(label)label.textContent='START REACTION';
      if(status)status.textContent='REACTION FAILED — TRY AGAIN';
      if(readout)readout.textContent='STANDBY';
    }
  });
}

function setupCatalyst(root){
  if(root.dataset.csReady)return;
  root.dataset.csReady='true';
  const filter=(category)=>{let shown=0;root.querySelectorAll('[data-cs-category]').forEach(card=>{card.hidden=category!=='all'&&card.dataset.csCategory!==category;if(!card.hidden)shown++;if(card.hidden)card.querySelector('audio')?.pause();});root.querySelectorAll('[data-cs-filter]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.csFilter===category)));root.querySelector('.cs-filter-empty').hidden=shown!==0;};
  root.querySelectorAll('[data-cs-filter]').forEach(button=>button.addEventListener('click',()=>filter(button.dataset.csFilter)));
  root.querySelectorAll('[data-cs-genre]').forEach(link=>link.addEventListener('click',()=>filter(link.dataset.csGenre)));
  root.querySelectorAll('audio').forEach(audio=>audio.addEventListener('play',()=>document.querySelectorAll('audio').forEach(other=>{if(other!==audio)other.pause();})));
}
document.querySelectorAll('.cs-home').forEach(root=>{setupCatalyst(root);setupCatalystSlider(root);setupCatalystRandomiser(root);});
document.addEventListener('shopify:section:load',()=>document.querySelectorAll('.cs-home').forEach(root=>{setupCatalyst(root);setupCatalystSlider(root);setupCatalystRandomiser(root);}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
